import script from "./SidebarToggler.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarToggler.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__